<template>
  <div class="custom-dimensional">
    <div class="three-dimensional-models-preview">
      <div v-if="props.threeDimensionalModelsInfo"
           class="three-dimensional-model-preview">
        <ThreeDimensional :label-by-id='`preview`'
                          :background-color="props.backgroundColor"
                          :three-dimensional-model-info="props.threeDimensionalModelsInfo"
                          draco-url="/assets/js/drco/gltf/" />
        <div class="preview-three-dimensional-model"
             @click="onPreview">
          <zoom-in-outlined />
          <span>{{ $t('CustomSpus.CustomEdit.preview') }}</span>
        </div>
      </div>
      <div v-else
           class="three-dimensional-model-preview no-model">
        <div class="no-model-hints">
          <img src="../../icon/exclamation-mark.png">
          <span class="remind">{{ $t('CustomSpus.CustomEdit.noModel') }}</span>
        </div>
      </div>
    </div>
    <div v-if="props.canvasActiveObject && props.reCreate"
         class="custom-edit">
      <div v-if="props.canvasActiveObject.type != 'i-text'"
           class="custom-edit-content">
        <div class="custom-edit-button">
          <a-tooltip>
            <template #title>{{ $t('CustomSpus.CustomEdit.maximize') }}</template>
            <div class="custom-edit-border cuboid"
                 @click="onEditing('maximize')">
              <fullscreen-outlined class="icon-size" />
            </div>
          </a-tooltip>
          <a-tooltip>
            <template #title>{{ $t('CustomSpus.CustomEdit.spreadOut') }}</template>
            <div class="custom-edit-border cuboid"
                 @click="onEditing('spreadOut')">
              <arrows-alt-outlined class="icon-size" />
            </div>
          </a-tooltip>
          <a-tooltip>
            <template #title>{{ $t('CustomSpus.CustomEdit.heightMaximization') }}</template>
            <div class="custom-edit-border cuboid"
                 @click="onEditing('heightMaximization')">
              <column-height-outlined class="icon-size" />
            </div>
          </a-tooltip>
          <a-tooltip>
            <template #title>{{ $t('CustomSpus.CustomEdit.widthMaximization') }}</template>
            <div class="custom-edit-border cuboid"
                 @click="onEditing('widthMaximization')">
              <column-width-outlined class="icon-size" />
            </div>
          </a-tooltip>
          <a-tooltip>
            <template #title>{{ $t('CustomSpus.CustomEdit.flipHorizontal') }}</template>
            <div class="custom-edit-border cuboid"
                 @click="onEditing('flipHorizontal')">
              <img v-show="!customAreaAdjustment.flipHorizontal"
                   class="flip-horizontal"
                   src="../../icon/flip-horizontal.png">
              <img v-show="customAreaAdjustment.flipHorizontal"
                   class="flip-horizontal"
                   src="../../icon/flip-horizontal-selected.png">
            </div>
          </a-tooltip>
          <a-tooltip>
            <template #title>{{ $t('CustomSpus.CustomEdit.flipVertical') }}</template>
            <div class="custom-edit-border cuboid"
                 @click="onEditing('flipVertical')">
              <img v-show="!customAreaAdjustment.flipVertical"
                   class="flip-vertical"
                   src="../../icon/flip-vertical.png">
              <img v-show="customAreaAdjustment.flipVertical"
                   class="flip-vertical"
                   src="../../icon/flip-vertical-selected.png">
            </div>
          </a-tooltip>
          <a-tooltip>
            <template #title>{{ $t('CustomSpus.CustomEdit.rotateLeft') }}</template>
            <div class="custom-edit-border cuboid"
                 @click="onEditingrRotate(true)">
              <img class="rotate"
                   src="../../icon/turn-left.png">
            </div>
          </a-tooltip>
          <a-tooltip>
            <template #title>{{ $t('CustomSpus.CustomEdit.rotateRight') }}</template>
            <div class="custom-edit-border cuboid"
                 @click="onEditingrRotate(false)">
              <img class="rotate"
                   src="../../icon/turn-right.png">
            </div>
          </a-tooltip>
        </div>
        <div class="custom-edit-silder">
          <a-row justify="space-around"
                 align="middle">
            <a-col :span="4">
              <span>{{ $t('CustomSpus.CustomEdit.rotate') }}</span>
            </a-col>
            <a-col :span="14">
              <a-slider v-model:value="customAreaAdjustment.rotate"
                        :min="-180"
                        :max="180" />
            </a-col>
            <a-col :span="4">
              <a-input-number v-model:value="customAreaAdjustment.rotate"
                              :min="-180"
                              :max="180"
                              class="silder-input-number" />
            </a-col>
          </a-row>
        </div>
        <div class="segmentation">
          <a-button class="segmentation-button"
                    type="primary"
                    :loading="segmentedLoading"
                    @click="onSegmentRequest">
            {{ segmentedIndex >= 0
              ? $t('CustomSpus.CustomEdit.restore')
              : $t('CustomSpus.CustomEdit.smartSegmentation')
            }}
            <a-tooltip v-show="segmentedIndex >= 0">
              <template #title>{{ $t('CustomSpus.CustomEdit.removeSolidBackground') }}</template>
              <QuestionCircleOutlined class="color-grey" />
            </a-tooltip></a-button>
        </div>
      </div>
      <div v-else
           class="custom-edit-content">
        <div class="custom-edit-button">
          <a-tooltip>
            <template #title>{{ $t('CustomSpus.CustomEdit.flipHorizontal') }}</template>
            <div class="custom-edit-border cuboid"
                 @click="onEditing('flipHorizontal')">
              <img v-show="!customAreaAdjustment.flipHorizontal"
                   class="flip-horizontal"
                   src="../../icon/flip-horizontal.png">
              <img v-show="customAreaAdjustment.flipHorizontal"
                   class="flip-horizontal"
                   src="../../icon/flip-horizontal-selected.png">
            </div>
          </a-tooltip>
          <a-tooltip>
            <template #title>{{ $t('CustomSpus.CustomEdit.flipVertical') }}</template>
            <div class="custom-edit-border cuboid"
                 @click="onEditing('flipVertical')">
              <img v-show="!customAreaAdjustment.flipVertical"
                   class="flip-vertical"
                   src="../../icon/flip-vertical.png">
              <img v-show="customAreaAdjustment.flipVertical"
                   class="flip-vertical"
                   src="../../icon/flip-vertical-selected.png">
            </div>
          </a-tooltip>
          <a-tooltip>
            <template #title>{{ $t('CustomSpus.CustomEdit.rotateLeft') }}</template>
            <div class="custom-edit-border cuboid"
                 @click="onEditingrRotate(true)">
              <img class="rotate"
                   src="../../icon/turn-left.png">
            </div>
          </a-tooltip>
          <a-tooltip>
            <template #title>{{ $t('CustomSpus.CustomEdit.rotateRight') }}</template>
            <div class="custom-edit-border cuboid"
                 @click="onEditingrRotate(false)">
              <img class="rotate"
                   src="../../icon/turn-right.png">
            </div>
          </a-tooltip>
        </div>
        <div class="custom-edit-silder">
          <a-row justify="space-around"
                 align="middle">
            <a-col :span="4">
              <span>{{ $t('CustomSpus.CustomEdit.rotate') }}</span>
            </a-col>
            <a-col :span="14">
              <a-slider v-model:value="customAreaAdjustment.rotate"
                        :min="-180"
                        :max="180" />
            </a-col>
            <a-col :span="4">
              <a-input-number v-model:value="customAreaAdjustment.rotate"
                              :min="-180"
                              :max="180"
                              class="silder-input-number" />
            </a-col>
          </a-row>
        </div>
        <div class="custom-edit-adjustment">
          <input v-model="customAreaAdjustment.fontColor"
                 type="color"
                 class="custom-edit-adjustment-color"
                 onchange="changeFontColor" />
          <a-dropdown>
            <template #overlay>
              <a-menu>
                <a-sub-menu v-for="value in fontList"
                            :title="value.name">
                  <a-menu-item v-for="font in value.file_path"
                               @click="changeFontFamily(font, value.name)"><img style="width: 120px;height: 24px;"
                         :src="toUrl(font.img)" /></a-menu-item>
                </a-sub-menu>
              </a-menu>
            </template>
            <a-button>
              <span>{{ currentFont ? currentFont : '默认字体' }}</span>
              <DownOutlined />
            </a-button>
          </a-dropdown>
          <a-select ref="select"
                    v-model:value="customAreaAdjustment.fontSize">
            <template v-for="item in fontSizeData">
              <a-select-option :value="item">{{ item }}</a-select-option>
            </template>
          </a-select>
        </div>
        <div class="custom-edit-stroke">
          <a-row justify="space-around"
                 align="middle">
            <a-col :span="4">
              <span>{{ $t('CustomSpus.CustomEdit.stroke') }}</span>
            </a-col>
            <a-col :span="10">
              <a-slider v-model:value="customAreaAdjustment.strokeWidth"
                        :min="0"
                        :max="20" />
            </a-col>
            <a-col :span="5">
              <a-input-number v-model:value="customAreaAdjustment.strokeWidth"
                              :min="0"
                              :max="20"
                              class="silder-input-number" />
            </a-col>
            <a-col :span="3">
              <input v-model="customAreaAdjustment.strokeColor"
                     type="color"
                     class="color-selection" />
            </a-col>
          </a-row>
        </div>
        <div class="custom-edit-button">
          <div class="custom-edit-border round"
               @click="onEditing('fontBold')">
            <bold-outlined :class="['icon-size', customAreaAdjustment.fontBold ? 'color-black' : '']" />
          </div>
          <div class="custom-edit-border round"
               @click="onEditing('fontItalic')">
            <italic-outlined :class="['icon-size', customAreaAdjustment.fontItalic ? 'color-black' : '']" />
          </div>
          <div class="custom-edit-border round"
               @click="onEditing('underline')">
            <underline-outlined :class="['icon-size', customAreaAdjustment.underline ? 'color-black' : '']" />
          </div>
          <div class="custom-edit-border round"
               @click="onEditing('linethrough')">
            <strikethrough-outlined :class="['icon-size', customAreaAdjustment.linethrough ? 'color-black' : '']" />
          </div>
          <div class="custom-edit-border round"
               @click="onEditingIText('left')">
            <align-left-outlined
                                 :class="['icon-size', customAreaAdjustment.textAlign === 'left' ? 'color-black' : '']" />
          </div>
          <div class="custom-edit-border round"
               @click="onEditingIText('center')">
            <align-center-outlined
                                   :class="['icon-size', customAreaAdjustment.textAlign === 'center' ? 'color-black' : '']" />
          </div>
          <div class="custom-edit-border round"
               @click="onEditingIText('right')">
            <align-right-outlined
                                  :class="['icon-size', customAreaAdjustment.textAlign === 'right' ? 'color-black' : '']" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch, computed } from 'vue'
import { ThreeDimensional } from '@iota-cn/ui-components'
import { selectedSpuData } from "../../index"
import { requestSegmentHDCommonImage } from "../../utils"
// import ThreeDimensional from "../ThreeDimensional.vue"
import type { ThreeDimensionalModelInfo, selectType, CustomAreaImgHistory, CustomFont, FontFile } from '../../types'
import { fetchFontList } from "../../api"
import { message } from 'ant-design-vue'
import { toUrl } from "@/utils"
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const props = defineProps<{
  threeDimensionalModelsInfo: ThreeDimensionalModelInfo
  canvasActiveObject: any
  backgroundColor: string
  segmentImg: string
  reCreate: boolean
}>()

const emit = defineEmits([
  'threeDimensionalmodalVisible',
  'onCustomAreaAdjustment',
  'onDefaultFont',
  'replaceImg',
  'imgLoading'
])

const segmentedIndex = computed(() => {
  return customAreaImgHistory.value.findIndex((r: CustomAreaImgHistory) => r.segmented === (props.segmentImg || props.canvasActiveObject.getSrc()))
})

const isSHOss = () => {
  return props.canvasActiveObject.getSrc().match('-sh.oss-') || props.canvasActiveObject.getSrc().match('-shanghai.oss-')
}

const currentFont = ref<string>('')
const segmentedLoading = ref<boolean>(false)
const system = ref<boolean>()
const fontSizeData = ref<Array<number>>([100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800])
const customAreaImgHistory = ref<CustomAreaImgHistory[]>([])
const fontList = ref<CustomFont[]>([])
const baseFontFamily = ref<selectType>()
const customAreaAdjustment = selectedSpuData().customAreaAdjustment

onMounted(async () => {
  await fetchFontList().then((res: any) => {
    fontList.value = res.data
  })
})

watch(() => customAreaAdjustment, () => {
  emit('onCustomAreaAdjustment', customAreaAdjustment)
}, {
  deep: true
})

watch(() => props.canvasActiveObject, (newV) => {
  if (!newV)
    return

  if (newV.type === 'i-text') {
    customAreaAdjustment.linethrough = newV.linethrough
    customAreaAdjustment.underline = newV.underline
    customAreaAdjustment.textAlign = newV.textAlign
    customAreaAdjustment.fontBold = newV.fontWeight === 'bold'
    customAreaAdjustment.fontItalic = newV.fontStyle === 'italic'
    customAreaAdjustment.strokeWidth = newV.strokeWidth
    customAreaAdjustment.strokeColor = newV.stroke
    baseFontFamily.value = newV.fontFamily
    customAreaAdjustment.fontFamily = newV.fontFamily
    customAreaAdjustment.fontColor = newV.fill
    customAreaAdjustment.fontSize = newV.fontSize
  }
  customAreaAdjustment.flipHorizontal = newV.flipX
  customAreaAdjustment.flipVertical = newV.flipY
  customAreaAdjustment.rotate = newV.angle
}, {
  deep: true
})

const onSegmentRequest = () => {
  const urlMappings: Record<string, string> = {
    "https://test.flashbase.com/resources": "https://flashbase-test-sh.oss-cn-shanghai.aliyuncs.com",
    "https://www.flashbase.com/resources": "https://flashbase-product-sh.oss-cn-shanghai.aliyuncs.com",
    "https://flashbase.com/resources": "https://flashbase-product-sh.oss-cn-shanghai.aliyuncs.com"
  }

  const originalUrl: string = props.canvasActiveObject.getSrc()

  const updatedUrl = Object.entries(urlMappings).reduce((url, [key, value]) =>
    url.startsWith(key) ? url.replace(key, value) : url, originalUrl
  )
  segmentedLoading.value = true

  if (segmentedIndex.value >= 0) {
    emit('replaceImg', customAreaImgHistory.value[segmentedIndex.value].history)
    customAreaImgHistory.value.splice(segmentedIndex.value, 1)
    segmentedLoading.value = false
    return
  }

  // 凭证由后端 svc-pms 代理持有，前端不接触 AccessKey；内置 3 次重试 + 500ms 轮询 + 60s 超时保护
  requestSegmentHDCommonImage(updatedUrl, {
    onSuccess: (resultImageUrl) => {
      emit('replaceImg', resultImageUrl)
      customAreaImgHistory.value.push({
        history: props.canvasActiveObject.getSrc(),
        segmented: resultImageUrl
      })
      endPolling(undefined)
    },
    onProcessFailed: () => endPolling(undefined, t('CustomSpus.CustomEdit.segmentationFailed')),
    onTimeout: () => endPolling(undefined, t('CustomSpus.CustomEdit.cpuOverloaded')),
  })
}

const endPolling = (polling: any, mes?: string) => {
  if (mes)
    message.error(mes)
  segmentedLoading.value = false
  clearInterval(polling)
}

const onPreview = () => {
  emit('threeDimensionalmodalVisible', true)
}

const changeFontFamily = async (value: FontFile, name: string) => {
  emit('imgLoading', true)
  const fontName = await loadFont(value)
  currentFont.value = name.slice(0, 3)
  customAreaAdjustment.fontFamily = fontName
  emit('imgLoading', false)
}

const loadFont = async (font: FontFile): Promise<string> => {
  const fontName = font.path.split('/')[4].split('.')[0]
  const fontUrl = toUrl(font.path)

  if (!document.getElementById(`font-${fontName}`)) {
    const style = document.createElement("style")
    style.id = `font-${fontName}`
    style.innerHTML = `
      @font-face {
        font-family: '${fontName}';
        src: url('${fontUrl}') format('truetype');
      }
    `
    document.head.appendChild(style)
  }

  try {
    await Promise.race([
      document.fonts.load(`1em ${fontName}`),
      new Promise<never>((_, reject) =>
        setTimeout(() => reject(new Error(`Font load timeout: ${fontName}`)), 20000)
      )
    ])
  } catch (error) {
    message.info('字体加载超时，可能是网络原因，重试后如果还有问题请联系开发人员！')
    console.warn(`[FontLoader] 超时继续执行: ${fontName}`, error)
  }
  return fontName
}

const onEditingrRotate = (anticlockwise: boolean) => {
  if (anticlockwise) {
    if (customAreaAdjustment.rotate < -135)
      customAreaAdjustment.rotate += 315
    else
      customAreaAdjustment.rotate -= 45
  } else {
    if (customAreaAdjustment.rotate > 135)
      customAreaAdjustment.rotate -= 315
    else
      customAreaAdjustment.rotate += 45
  }
}

const onEditing = (adjustment: string) => {
  customAreaAdjustment[adjustment] = !customAreaAdjustment[adjustment]
}

const onEditingIText = (alignment: string) => {
  customAreaAdjustment.textAlign = alignment
}

</script>

<style scoped lang="less">
.custom-dimensional {
  height: 100%;
  width: 100%;
  background-color: white;
  padding: 10px;
  display: flex;
  flex-flow: column;

  .color-selection {
    width: 100%;
    border: none;
  }

  .custom-edit-adjustment-color {
    width: 65px;
    height: 40px;
    background: #F6F6F6;
    padding: 2px 15px;
    border: none;
  }

  .custom-edit {
    margin-top: 50px;
    padding: 20px 10px;
    border-top: 1px solid #F6F6F6;
    border-width: 1px;
    width: 100%;
    flex: 1;

    .segmentation {
      width: 100%;

      .segmentation-button {
        width: 100%;
        height: 40px;
      }
    }

    .custom-edit-content {
      width: 100%;
      height: 100%;

      .custom-edit-border {
        margin-top: 20px;
        cursor: pointer;
        background-color: #F6F6F6;
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-wrap: wrap;
      }

      .custom-edit-button {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .icon-size {
          color: #999999;
          font-size: 20px;
        }

        :hover .icon-size {
          color: #afb4db;
        }
      }

      .custom-edit-adjustment {
        padding-top: 20px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .custom-edit-adjustment-select {
          width: 100px;
        }
      }

      .custom-edit-stroke {
        padding-top: 20px;

        .silder-input-number {
          width: 50px;
        }
      }
    }

    .custom-edit-silder {
      width: 100%;
      padding: 20px 0;

      .silder-input-number {
        width: 50px;
      }
    }
  }

  .cuboid {
    height: 40px;
    width: 25%;

    .flip-horizontal {
      width: 20px;
      height: 18px;
    }

    .flip-vertical {
      width: 18px;
      height: 20px;
    }

    .rotate {
      width: 20px;
      height: 20px;
    }

    img:hover {
      opacity: 0.6;
    }
  }

  .round {
    height: 30px;
    width: 14.2%;
  }

  .no-model {
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url(../../icon/clothes-model.png);
  }

  .three-dimensional-models-preview {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    overflow: auto;

    .three-dimensional-model-preview {
      width: 248px;
      height: 241px;
      position: relative;
      overflow: hidden;
      margin-top: 60px;

      .no-model-hints {
        width: 100%;
        height: 100%;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;

        img {
          width: 73px;
          height: 73px;
        }

        .remind {
          font-size: 30px;
          font-family: 'Microsoft YaHei';
          font-weight: 400;
          color: #CCCCCC;
        }
      }

      .preview-three-dimensional-model {
        cursor: pointer;
        position: absolute;
        width: 75px;
        height: 25px;
        right: 0px;
        bottom: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-top-left-radius: 10px;
        // border-bottom-right-radius: 10px;
        background-color: #bababa;
        z-index: 9;
        box-shadow: 0px 0px 5px 1px rgb(215, 214, 214);

        span {
          color: white;
          padding-left: 5px;
        }
      }
    }
  }

  .code-box-demo .ant-slider {
    margin-bottom: 16px;
  }
}

:deep(.ant-slider-rail) {

  background-color: #f5f5f574 !important;
}

:deep(.ant-slider-track) {

  background-color: black !important;
}

:deep(.ant-slider-handle) {
  background-color: black;
  border: none;
  border-radius: 0;
}

.color-black {
  color: black !important;
}
</style>
